import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { ToolsMissingDoctorRecordGridObject, WorkplaceGridObject } from '@it2go/types';

@Injectable()
export class ToolsMissingDoctorRecordsPageStore extends ComponentStoreV2Factory {

    gridData = computed<ToolsMissingDoctorRecordGridObject>(() => this.data.getMissingDoctorRecords() || null);
    workplaces = computed<WorkplaceGridObject>(() => this.data.getWorkplaces()?.items || []);

    public services = computed(() => {
        return this.globalGlobalStore.organizationStore.servicesInContext().filter((it) =>
            (this.globalGlobalStore.isAllowedForService('doctorWork.read', it.id)() || this.globalGlobalStore.isAllowedForService('work.read', it.id)()) && it.expertise?.code === '926',
        );
    });

}
